import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityRequestAprv } from "../../entity/EntityRequestAprv";

export class DtoRequestAprvsPostReq extends EntityRequestAprv {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------

    return res;
  }
}
